module.exports = __webpack_public_path__ + "static/media/Latin-Merriweather-Regular.efc70b44.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/merriweather/Latin-Merriweather-Regular.ttf
// module id = 517
// module chunks = 0